import { createContextAwareHook } from './useContextAwareHook';
import {
  useGetSetAsideQuery,
  usePublicGetSetAsideQuery,
  useGetSetAsideDefaultsQuery,
  usePublicGetSetAsideDefaultsQuery,
  useUpdateSetAsideMutation
} from '../features/modules/setAsideApiSlice';

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting set aside data based on the current route.
 */
export const useContextAwareGetSetAside = createContextAwareHook(
  useGetSetAsideQuery,
  usePublicGetSetAsideQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting set aside defaults based on the current route.
 */
export const useContextAwareGetSetAsideDefaults = createContextAwareHook(
  useGetSetAsideDefaultsQuery,
  usePublicGetSetAsideDefaultsQuery
);

// Export mutation hooks directly
export {
  useUpdateSetAsideMutation
}; 